window.addEventListener("load",function(){
  let wh = $(window).height()
  let ww = $(window).width()
  let flag = true
 window.addEventListener("scroll",function(){
     var scrollTop = $(document).scrollTop()
    if( $("span[data-number][data-number != '']").length > 0){
        let top = $("span[data-number][data-number != '']").parents(".shopify-section").offset().top
        let he = $("span[data-number][data-number != '']").parents(".shopify-section").height()
         if(scrollTop > (top - wh + he) && ww > 750 && flag ){
             $("span[data-number][data-number != '']").each(function(i){
               NumAutoPlusAnimation($(this).data("speed"),0,$(this).data("number"),$(this))
             })
           flag = false
         }
    }
  })
})

 function NumAutoPlusAnimation(speed,baseNumber, finalNum,numBox) {
    var step = (finalNum - baseNumber) / speed;
    var count = baseNumber; 
    var initial = 0;
    var timer = setInterval(() => {
      count = count + step;
      if (count >= finalNum) {
        clearInterval(timer);
        count = finalNum;
      }
      var t = count.toFixed(0);
      initial = t;
      numBox.html(initial);
    }, 30);
  }